// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "fd8ea9eb57fa04ef14732dbb8b196938" + ".js";
};